import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { PageResponse, Pagination } from '@core/shared/domain';

import {
  AddArticleToFavoritesList,
  CreateFavoritesList,
  FavoritesList,
  FavoritesListArticle,
  UpdateFavoritesList,
} from '../../common';

export const FavoritesActions = createActionGroup({
  source: 'Medical Shop - Favorites',
  events: {
    'Fetch favorites lists': emptyProps(),
    'Fetch favorites lists success': props<{
      favoritesLists: Array<FavoritesList>;
    }>(),
    'Fetch favorites lists error': emptyProps(),

    'Fetch favorite list articles': props<{
      listId: string;
      pagination?: Pagination;
    }>(),
    'Fetch favorite list articles success': props<{
      favoriteListArticlesPageResponse: PageResponse<FavoritesListArticle>;
    }>(),
    'Fetch favorite list articles error': emptyProps(),

    'Favorite list articles clear': emptyProps(),

    'Create favorites list': props<{
      createDto: CreateFavoritesList;
    }>(),
    'Create favorites list success': props<{
      createdList: FavoritesList;
      globalArticleId?: string;
    }>(),
    'Create favorites list error': emptyProps(),

    'Update favorites list': props<{
      listId: string;
      updateDto: UpdateFavoritesList;
    }>(),
    'Update favorites list success': props<{
      updatedList: FavoritesList;
    }>(),
    'Update favorites list error': emptyProps(),

    'Favorites list update': props<{
      updatedList: FavoritesList;
    }>(),

    'Delete favorites list': props<{
      listId: string;
    }>(),
    'Delete favorites list success': props<{
      listId: string;
    }>(),
    'Delete favorites list error': emptyProps(),

    'Delete favorite list article': props<{
      listId: string;
      globalArticleId: string;
    }>(),
    'Delete favorite list article success': props<{
      updatedList: FavoritesList;
    }>(),
    'Delete favorite list article error': emptyProps(),
  },
});

export const FavoritesMenuActions = createActionGroup({
  source: 'Medical Shop - Favorites Menu',
  events: {
    'Add favorite list article': props<{
      addToListDto: AddArticleToFavoritesList;
    }>(),
    'Add favorite list article success': props<{ listId: string }>(),
    'Add favorite list article error': emptyProps(),

    'Delete favorite list article': props<{
      listId: string;
      globalArticleId: string;
    }>(),
    'Delete favorite list article success': props<{
      updatedList: FavoritesList;
    }>(),
    'Delete favorite list article error': emptyProps(),
  },
});
